/** Page size that means "every matching row" for list and board pagination. */
export const ALL_ROWS_PAGE_SIZE = 1000000;

/** Rows-per-page choices shown in the shared list and board footer. */
export const LIST_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, ALL_ROWS_PAGE_SIZE];

const STORAGE_PREFIX = "listBoardPageSize:";

/**
 * Label for a rows-per-page option. The All sentinel is shown as "All".
 * @param {number|string} value
 * @return {string}
 */
export function formatListPageSizeOption(value) {
  return Number(value) === ALL_ROWS_PAGE_SIZE ? "All" : `${value} / page`;
}

/**
 * @param {string} orderType
 * @return {string}
 */
const storageKey = orderType => `${STORAGE_PREFIX}${orderType}`;

/**
 * Read the saved rows-per-page value for a module.
 * @param {string} orderType
 * @return {number|null}
 */
export function readListPageSize(orderType) {
  if (!orderType || typeof window === "undefined") return null;
  try {
    const size = Number(window.localStorage.getItem(storageKey(orderType)));
    if (!Number.isFinite(size) || size <= 0) return null;
    return size;
  } catch (_) {
    return null;
  }
}

/**
 * Remember the rows-per-page value for a module.
 * @param {string} orderType
 * @param {number} size
 * @return {void}
 */
export function writeListPageSize(orderType, size) {
  if (!orderType || typeof window === "undefined") return;
  const numeric = Number(size);
  if (!Number.isFinite(numeric) || numeric <= 0) return;
  try {
    window.localStorage.setItem(storageKey(orderType), String(numeric));
  } catch (_) {
    /* ignore quota or private mode */
  }
}

/**
 * Apply a stored page size before the first list or board request.
 * Local storage wins over the account preference already copied into params.
 * @param {string} orderType
 * @param {Object} params
 * @return {Object}
 */
export function withStoredPageSize(orderType, params = {}) {
  const stored = readListPageSize(orderType);
  if (!stored) return params;
  if (Number(params?.limit) === stored) return params;
  return { ...params, limit: stored, offset: 0 };
}
